<template>
  <div>
    <el-dialog
      :title="$t('lang.' + dialogTitle)"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="30%"
    >
      <el-form
        :model="levelForm"
        ref="levelForm"
        :rules="rules"
        :hide-required-asterisk="true"
        label-width="130px"
      >
        <el-form-item :label="$t('lang.层级名称')" prop="rootName">
          <el-input
            v-model="levelForm.rootName"
            :placeholder="$t('lang.请输入层级名称')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.详细地址')" prop="detailAddress">
          <el-input
            v-model="levelForm.detailAddress"
            :placeholder="$t('lang.请输入详细地址街道楼牌号等')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSubmit">
          {{ $t("lang.确定") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    var rootNameRule = (rule, value, callback) => {
      let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
      if (reg.test(value)) {
        callback(new Error(this.$t("lang.不能有特殊字符")));
      } else if (value.trim() == "") {
        callback(new Error(this.$t("lang.请输入层级名称")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      dialogTitle: "添加层级",
      levelForm: {
        rootName: "",
        detailAddress: "",
      },
      levelType: 1,
      rules: {
        rootName: [
          {
            required: true,
            validator: rootNameRule,
            trigger: "blur",
          },
        ],
        detailAddress: [
          {
            required: true,
            message: this.$t("lang.请输入详细地址街道楼牌号等"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      simpleLevelAdd: "ZD_SimpleLevelAdd",
      simpleLevelUpdate: "ZD_SimpleLevelUpdate",
    }),
    dialogShow(type, item) {
      this.dialogVisible = true;
      this.levelType = type;
      type == 1
        ? (this.dialogTitle = "添加层级")
        : (this.dialogTitle = "修改层级");
      if (item) {
        this.levelForm = { ...item };
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.levelForm.resetFields();
      this.levelForm.rootName = "";
      this.levelForm.detailAddress = "";
    },
    async onClickSubmit() {
      let params = {
        value: { ...this.levelForm },
      };
      try {
        await this.$refs.levelForm.validate();
        if (this.levelType == 1) {
          params.value.rootName = params.value.rootName.trim();
          let res = await this.simpleLevelAdd(params);
          if (res.success !== 1) return;
          this.$message({
            message: this.$t("lang.添加成功"),
            type: "success",
          });
        } else {
          let res = await this.simpleLevelUpdate(params);
          if (res.success !== 1) return;
          this.$message({
            message: this.$t("lang.修改成功"),
            type: "success",
          });
        }
        this.handleClose();
        this.$parent.getSimpleLevelList();
      } catch {}
    },
  },
};
</script>

<style scoped lang='less'>
.el-form {
  padding-left: 40px;
}
.el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
}
</style>